import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {CookiesProvider} from "react-cookie";
import {CssVarsProvider, GlobalStyles} from "@mui/joy";
import theme from "./theme";
import {RouterProvider} from "react-router-dom";
import {router} from "./router";
import "@fontsource/orbitron"
// Loaded for its side effect: i18next is initialised on import
import "./localization"
import ApiServiceContext from "./context/ApiServiceContext";
import FeedbackContext from "./context/FeedbackContext";
import AuthContext from "./context/AuthContext";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <CookiesProvider defaultSetOptions={{path: '/'}}>
            <GlobalStyles styles={{
                "& .lucide": {
                    color: "var(--Icon-color,inherit)",
                    margin: "var(--Icon-margin)",
                    fontSize: "var(--Icon-fontSize, 20px)",
                    width: "0.85em",
                    height: "0.85em"
                }
            }}/>
            <FeedbackContext>
                <ApiServiceContext>
                    <CssVarsProvider
                        theme={theme}
                        defaultMode={"dark"}>
                        {/*
                          * Above the router so the session is resolved once, for the guards and the
                          * layout alike, and under the theme because it renders the auth dialog.
                          */}
                        <AuthContext>
                            <RouterProvider router={router}/>
                        </AuthContext>
                    </CssVarsProvider>
                </ApiServiceContext>
            </FeedbackContext>
        </CookiesProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
